import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { fetchTrainerMe } from "@/api/trainerAuth";

export default function TrainerProtectedRoute({ children }) {
  const [ok, setOk] = useState(null);

  useEffect(() => {
    fetchTrainerMe()
      .then(() => setOk(true))
      .catch(() => setOk(false));
  }, []);

  if (ok === null) return null;
  if (!ok) return <Navigate to="/trainer-login" replace />;

  return children;
}
